import { cardsGrid } from 'components/items-layout/base';
import { css } from 'linaria';
import { breakpointSmallTablet } from 'common/constants';
import { breakpointTinyTablet } from 'common/constants';
import { breakpointLargeHandset } from 'common/constants';
export const ruler = "ranq9ty";
export const cardGrid = "c1qfws8i";
export const cardList = "c3iqxh2";
export const cardDetail = "c1yvxwmt";

require("./virtualized-list.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./virtualized-list.js");